<script setup lang="ts">
  import { computed } from "vue";
  import { useMAssetLibraryStore } from "@stores/mAssetLibrary";
  import { aspectRatioLabel, formatFileSize, mediaFormatLabel } from "@utils/media";
  import type { MMediumUpload } from "@/types";

  const props = defineProps<{ asset: MMediumUpload }>();

  const { dimensionsOf } = useMAssetLibraryStore();

  const rows = computed(() => {
    const dimensions = dimensionsOf(props.asset);
    const uploadedOn = props.asset.created_at ? new Date(props.asset.created_at).toLocaleDateString() : null;
    return [
      { label: "Dimensions", value: dimensions ? `${dimensions.width} × ${dimensions.height}` : null },
      { label: "Ratio", value: dimensions ? aspectRatioLabel(dimensions) : null },
      { label: "Size", value: formatFileSize(props.asset.byte_size) || null },
      { label: "Format", value: mediaFormatLabel(props.asset.content_type, props.asset.url) || null },
      { label: "Uploaded", value: [uploadedOn, props.asset.uploader_name].filter(Boolean).join(" · ") || null },
      { label: "Copies", value: (props.asset.same_url_count ?? 1) > 1 ? `${props.asset.same_url_count} uploads of this file` : null },
    ].filter((row) => row.value);
  });
</script>

<template>
  <dl class="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-xs">
    <template
      v-for="row in rows"
      :key="row.label">
      <dt class="text-muted-foreground">{{ row.label }}</dt>
      <dd class="truncate text-foreground">{{ row.value }}</dd>
    </template>
  </dl>
</template>
